$(window).scroll(function() {
    // Code from websensepro.com
    //After scrolling 300px from the top...
      $('.sticky_add_cart').click(function(){
        $('.product__submit__add:not(.sticky_add_cart)').trigger('click');
      });
     if ($(window).width() > 767) { 
    if ( $(window).scrollTop() >= 800 ) {
        $('.sticky-button').css('position', 'fixed');
        $('.sticky-button').addClass('sticky_atc_shown');
    //Otherwise remove inline styles and thereby revert to original stying
    } else {
        $('.sticky-button').attr('style', '');
$('.sticky-button').removeClass('sticky_atc_shown');
    }
     }else{
        if ( $(window).scrollTop() >= 1000 ) {
        $('.sticky-button').css('position', 'fixed');
        $('.sticky-button').addClass('sticky_atc_shown');
    //Otherwise remove inline styles and thereby revert to original stying
    } else {
        $('.sticky-button').attr('style', '');
     $('.sticky-button').removeClass('sticky_atc_shown');
    }
     }
});

